import { useSelector } from 'react-redux';

import { abGroupSelector } from '../../selectors/abGroupSelector';

export function useAbGroupSelector(): number {
  return useSelector(abGroupSelector);
}
